export enum MenuSectionNameOptions {
  SOUP = "Soupe",
  MAIN = "Plat Principal",
  DESSERT = "Dessert",
  OTHERS = "Autres",
  FRUIT = "Fruit",
  PROTEIN = "Protéine",
  BREAD = "Pain",
  DAIRY = "Produit Laitier",
  CEREAL = "Céréale",
}

export const REGULAR_MENU_SECTION_OPTIONS: MenuSectionNameOptions[] = [
  MenuSectionNameOptions.SOUP,
  MenuSectionNameOptions.MAIN,
  MenuSectionNameOptions.DESSERT,
  MenuSectionNameOptions.OTHERS,
];

export const BREAKFAST_MENU_SECTION_OPTIONS: MenuSectionNameOptions[] = [
  MenuSectionNameOptions.FRUIT,
  MenuSectionNameOptions.PROTEIN,
  MenuSectionNameOptions.BREAD,
  MenuSectionNameOptions.DAIRY,
  MenuSectionNameOptions.CEREAL,
  MenuSectionNameOptions.OTHERS,
];

// Until menus carry a breakfast meal type, all options are shown everywhere.
export const getMenuSectionNameOptions = (): MenuSectionNameOptions[] => [
  ...REGULAR_MENU_SECTION_OPTIONS,
  ...BREAKFAST_MENU_SECTION_OPTIONS.filter(
    (option) => !REGULAR_MENU_SECTION_OPTIONS.includes(option),
  ),
];

export enum SideOptionGroupNameOptions {
  SAUCE = "Sauce",
  CARBOHYDRATE = "Carbohydrate",
  VEGETABLE = "Vegetable",
  PROTEIN = "Protein",
  GARNISH = "Garnish",
}

export const SIDE_OPTION_GROUP_NAME_OPTIONS: SideOptionGroupNameOptions[] = [
  SideOptionGroupNameOptions.SAUCE,
  SideOptionGroupNameOptions.CARBOHYDRATE,
  SideOptionGroupNameOptions.VEGETABLE,
  SideOptionGroupNameOptions.PROTEIN,
  SideOptionGroupNameOptions.GARNISH,
];

export enum MenuItemIndexOptions {
  ALL = "All",
  FIRST = "1st",
  SECOND = "2nd",
  THIRD = "3rd",
  FOURTH = "4th",
  FIFTH = "5th",
  SIXTH = "6th",
  SEVENTH = "7th",
  EIGHTH = "8th",
  NINTH = "9th",
  TENTH = "10th",
}
